<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-10" ref="spacer"></div>
        <base-back-button />
        <div class="px-4 sm:px-0">
          <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">{{ pageTitle }}</h2>

          <base-message-box v-if="renewalWarning" class="mt-4">
            <template slot="content">
              <p>Le recomendamos <strong>renovar la fotografía</strong> para evitar errores en el acceso a las instalaciones. Para ello ha de <strong>revocar el consentimiento</strong> de la fotografía actual.</p>
            </template>
          </base-message-box>

          <biometric-access-enabled @revoke="openRevoke"></biometric-access-enabled>

          <div class="leading-1 mt-8">
            <p>El reconocimiento facial es una <strong>tecnología segura</strong> que le permitirá acceder a las instalaciones de forma rápida <strong>sin necesidad de presentar ningún documento</strong> en los tornos de entrada.</p>
          </div>
        </div>
        <div class="h-10"></div>
        <div class="px-4 sm:px-0"></div>
      </div>

      <base-modal v-model="open">
        <template v-slot:title>Revocación acceso biometríco</template>
        <p>Va a proceder a revocar el consentimiento del acceso biométrico a las instalaciones. Podrá volver a iniciar este proceso en cualquier momento.</p>
        <p class="mt-3">¿Desea continuar con la revocación del acceso biométrico?</p>
        <template v-slot:actions>
          <base-button mode="secondary-phantom" text="Cancelar" @click="cancel" />
          <el-button @click="revoke" type="danger" :loading="loading">Sí, revocar</el-button>
        </template>
      </base-modal>
    </div>
  </div>
</template>

<script>
import BiometricAccessEnabled from '@/components/biometric/BiometricAccessEnabled'
import { handleScrollMixin } from '@/mixins/appMixin'
import BiometricServices from '@/services/biometrics'

export default {
  name: 'BiometricConfigDone',
  components: {
    BiometricAccessEnabled
  },
  mixins: [handleScrollMixin],
  data: function () {
    return {
      loading: false,
      pageTitle: 'Estado de acceso biométrico',
      open: false
    }
  },
  computed: {
    membership: function () {
      return this.$store.getters['auth/membership']
    },
    renewalWarning: function () {
      return this.$store.getters['auth/renewalWarning']
    }
  },
  methods: {
    openRevoke: function () {
      this.open = true
    },
    revoke: async function () {
      try {
        this.loading = true
        await BiometricServices.revoke(this.membership)
        this.$emit('update')
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loading = false
      }
    },
    cancel: function () {
      this.open = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
